<template v-if="widgetReady">
    <ac-modal :title="modalTitle" :size-class="'modal-md'" ref="modalRef">
        <template>
            <div class="row">
                <div class="info-board info-board-blue">
                    <div class="row">
                        <div class="col-lg-12">
                            <p class="text-primary">
                                <small>
                                    <em>
                                        {{ message }}
                                    </em>
                                </small>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Select</th>
                                <th>Name</th>
                                <th>Relationship</th>
                                <th>DOB</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <input type="checkbox" class="form-control select-checkbox" v-model="primaryIsSelected"
                                        id="primary" @change="toggleAllDependents"
                                        title="Terminating Primary terminates entire family.">
                                </td>
                                <td>
                                    <label for="primary">{{ primary ?
                                        primary.participantName
                                        : '' }}</label>
                                </td>
                                <td>
                                    <p>Primary</p>
                                </td>
                                <td>
                                    <p>{{ primary.birthDate | shortDate }}</p>
                                </td>
                            </tr>
                            <tr v-for="d in dependents" :key="d.consumerId">
                                <td>
                                    <input type="checkbox" class="form-control select-checkbox" v-model="d.isSelected"
                                        :id="'dependent-to-terminate-' + d.consumerId" :disabled="primaryIsSelected">
                                </td>
                                <td>
                                    <label :for="'dependent-to-terminate-' + d.consumerId">{{ d.participantName }}</label>
                                </td>
                                <td>
                                    <p>{{ d.relationshipToConsumer }}</p>
                                </td>
                                <td>
                                    <p>{{ d.birthDate | shortDate }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <div class="col-lg-4 form-group">
                        <label>
                            Termination Date
                            <small class="redText">required</small>
                        </label><br />
                        <ac-date-picker v-model="effEndDate" :useTodayAsDefault="true" v-if="!disableTermDatePicker"></ac-date-picker>
                        <input v-else type="text" class="form-control" :disabled="true" v-model="effEndDate" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12" style="text-align: right;">
                    <ac-button class="btn-sm btn-red wl-btn-failure button-size" :action="closeModal">
                        CANCEL
                    </ac-button>
                    <ac-button class="btn-sm btn-success wl-btn-success button-size" :action="termDependents">
                        TERMINATE
                    </ac-button>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>

import { api } from "@/global/framework/api.js";
import { configTables } from "../../../global/configTables.js";
import { notifications } from "../../../global/notifications";
import moment from 'moment';

export default {
    name: "TermDependentsModal",
    components: {},
    data() {
        return {
            model: { companyId: 0, fullName: '', consumerId: 0 },
            family: [],
            primary: {},
            primaryIsSelected: false,
            dependents: [],
            relationshipTypes: [],
            widgetReady: false,
            effEndDate: new Date(),
            disableTermDatePicker: false
        }
    },
    computed: {
        modalTitle() {
            return `Manage Members - ${this.model.fullName}`;
        },
        message() {
            return `You are about to terminate ${this.model.fullName} or their family members.
                      Doing so will take effect immediately and disable
                      the member’s access to Accresa and its services.`
        }
    },
    methods: {
        async showModal({ companyId: companyId, consumerId: consumerId, fullName: fullName }) {
            this.model = { companyId, consumerId, fullName };
            this.family = await api.getDataWithTwoIds("Company", companyId, "GetFamily", consumerId);

            let employeeData = await api.getDataWithTwoIds("Company", companyId, "GetEditEmployeeModel", consumerId);
            console.log("Employee Data: ", {employeeData: employeeData});
            if(employeeData.future && employeeData.future.consumerCoverageId > 0) {
                this.effEndDate = new Date(employeeData.future.effectiveDate).toLocaleDateString();
            }
                      
            this.primary = this.family.find(member => member.relationshipToConsumer === "Primary");
            this.dependents = this.family.filter(member => member.relationshipToConsumer != "Primary" && member.isTerminated === false)
            if (this.dependents.some(dependent => dependent.relationshipToConsumer === "Spouse")) {
                this.dependents.sort((a, b) => {
                    if (a.relationshipToConsumer === "Spouse") return -1;
                    if (b.relationshipToConsumer === "Spouse") return 1;
                    return 0;
                })
            }
            if (this.primary) {
                this.widgetReady = true;
                this.$refs.modalRef.open();
            }
        },
        closeModal() {
            this.$emit("modal-closed");
            this.$refs.modalRef.close();
        },
        toggleAllDependents() {
            this.dependents.forEach(d => {
                if (this.primaryIsSelected) {
                    d.isSelected = true;
                }
                else {
                    d.isSelected = false;
                }
            })

        },
        async termDependents() {
            if (!this.primaryIsSelected && this.dependents.every(d => !d.isSelected)) {
                notifications.showError({ message: "No members selected for termination.", title: "Error" });
                return;
            }
            if(moment(this.effEndDate).startOf('day').isBefore(moment().startOf('day'))){
                notifications.showError({ message: "The termination date must not be in the past.", title: "Error" });
                return;
            }
            let result;
            if (this.primaryIsSelected) {
                result = await api.post("Company", "TermEmployee", { consumerId: this.primary.consumerId, effDate: this.effEndDate });
            } else {
                let selection = [];
                for (let i = 0; i < this.dependents.length; i++) {
                    if (this.dependents[i].isSelected) {
                        this.dependents[i].company = {};
                        this.dependents[i].company.companyId = this.model.companyId;
                        this.dependents[i].primaryId = this.primary.consumerId;
                        let relItem = _.find(this.relationshipTypes, (current) => {
                            return current.relationType == this.dependents[i].relationshipToConsumer;
                        });

                        this.$set(this.dependents[i], 'relationshipToPrimary', relItem.relationshipsEnum);
                        this.$set(this.dependents[i], 'effEndDate', this.effEndDate);
                        selection.push(this.dependents[i]);
                    }
                }
                result = await api.postDataAsJson("Company", "TermDependents", selection);
            }
            this.closeModal();

        }

    },
    async mounted() {
        await configTables.getRelationshipsToPrimary()
            .then((r) => this.relationshipTypes = r);
    },
}
</script>

<style scoped>
.select-checkbox {
    position: unset;
    visibility: visible;
    height: 20px;
    width: 20px;
    margin: 0px 0px 5px;
}

tr,
td,
label {
    vertical-align: unset !important;
}

p {
    margin: 0px 0px 5px;
}
</style>